module.exports = "/_next/static/images/powder-0e6a1c51cfbecb146c098c4d5aa41a57.png";